import _ from 'lodash';
// import moment from 'moment';
import axios from 'axios';

import { coinDesc } from './const';

async function getNetworkInfo(coin) {
  const now = Date.now();

  // const blocks = _.flatten(await Promise.all([
  //   moment().utc().format('YYYYMMDD'),
  //   moment().subtract(1, 'day').utc().format('YYYYMMDD')
  // ].map(async d => {
  //   const { data: { data } } = await axios.get(`https://api.i43.io/${coin.toLowerCase()}/v3/block/date/${d}`);
  //   return data;
  // })));

  // const blocks24h = blocks.filter(b => now / 1000 - b.timestamp <= 86400);
  const { data: blocks24h } = await axios.get(
    `https://8xiscecoe2.execute-api.ap-northeast-1.amazonaws.com/production/chain/${coin.toLowerCase()}/blocks`,
    { params: { start: now - 86400 * 1000, end: now } }
    );
  const totalDifficulty = _.sumBy(blocks24h, 'difficulty') - _.last(blocks24h).difficulty;
  const totalBlocktime = _.last(blocks24h).timestamp - _.first(blocks24h).timestamp;

  return {
    coin,
    blockHeight: blocks24h[0].height,
    halvingTs: Date.now() + (coinDesc[coin].halvingBlock - blocks24h[0].height) * 600 * 1000,
    miningEarning: blocks24h[0].reward / 10 ** 8 * 86400 / blocks24h[0].difficulty / 2 ** 32,
    totalReward24h: _.sumBy(blocks24h, b => b.reward / 10 ** 8),
    hashrate: totalDifficulty / totalBlocktime * 2 ** 32
  };
}

async function getQuotes() {
  const { data: { data } } = await axios.get('https://8xiscecoe2.execute-api.ap-northeast-1.amazonaws.com/production/quotes/latest');
  return _.map(data, v => ({
    coin: v.symbol,
    name: v.name,
    price: v.quote.USD.price,
    volume24h: v.quote.USD.volume_24h,
    percentChange24h: v.quote.USD.percent_change_24h
  }));
}

const BTC = {
  getNetworkInfo: () => getNetworkInfo('BTC')
};

const BCH = {
  getNetworkInfo: () => getNetworkInfo('BCH')
};

const ETH = {
  getNetworkInfo: async () => {
    const { data: { data } } = await axios.get('https://explorer-web.api.btc.com/v1/eth/stats/summary');
    return {
      coin: 'ETH',
      miningEarning: data.earning_eth / 10 ** 6,
      blockHeight: data.total_blocks,
      totalReward24h: data.earning_eth * data.hashrate * 1000,
      hashrate: data.hashrate * 10 ** 9
    };
  }
};

export { getQuotes }
export default { BTC, BCH, ETH }